import { useNavigate } from "react-router-dom";
import {
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Box,
  Chip,
} from "@mui/material";
import { MdEdit, MdDelete, MdCheckCircle } from "react-icons/md";
import { useCelularesContext } from "../celulares-context";

export function CelularesTable() {
  const navigate = useNavigate();

  const { celulares, deleteCelular, verifyCelular } = useCelularesContext();

  return (
    <Paper
      sx={{ padding: 1 }}
      className="animate__animated animate__fadeIn"
      variant="outlined"
    >
      <Stack>
        <Stack justifyContent="space-between" direction="row" padding={2}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="h6">Números de celular</Typography>
          </Stack>

          {/* <Button
            variant="contained"
            color="success"
            size="small"
            fullWidth={false}
            onClick={() => navigate("add")}
          >
            Agregar
          </Button> */}
        </Stack>

        {!!celulares.length ? (
          <Box>
            <TableContainer>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    {[
                      "#",
                      "Número de celular",
                      // "Estado",
                      // "Opciones"
                    ].map((label, i) => (
                      <TableCell key={i}>{label}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {celulares.map((celular, index) => (
                    <TableRow key={celular.celular_id}>
                      <TableCell>{index + 1}</TableCell>

                      <TableCell>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Typography variant="body2">
                            <a
                              href={`https://wa.me/504${String(
                                celular.celular_numero
                              ).replace("-", "")}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {celular.celular_numero}
                            </a>
                          </Typography>

                          {!!celular.celular_principal && (
                            <Chip
                              label="Principal"
                              size="small"
                              color="success"
                              variant="outlined"
                            />
                          )}
                        </Stack>
                      </TableCell>

                      {/* <TableCell>
                        <Chip
                          label={
                            !!celular.celular_verificado
                              ? "Verificado"
                              : "Pendiente"
                          }
                          color={
                            !!celular.celular_verificado ? "success" : "warning"
                          }
                          variant="outlined"
                          size="small"
                        />
                      </TableCell>

                      <TableCell align="center">
                        {!celular.celular_verificado ? (
                          <Stack direction="row" justifyContent="center">
                            <Tooltip title="Verificar">
                              <IconButton
                                color="success"
                                size="small"
                                onClick={async () =>
                                  await verifyCelular({
                                    celularId: celular.celular_id,
                                  })
                                }
                              >
                                <MdCheckCircle />
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Modificar">
                              <IconButton
                                color="warning"
                                size="small"
                                onClick={() =>
                                  navigate(`${celular.celular_id}/edit`)
                                }
                              >
                                <MdEdit />
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Eliminar">
                              <IconButton
                                color="error"
                                size="small"
                                onClick={async () => {
                                  await deleteCelular({
                                    celularId: celular.celular_id,
                                  });
                                }}
                              >
                                <MdDelete />
                              </IconButton>
                            </Tooltip>
                          </Stack>
                        ) : (
                          "-"
                        )}
                      </TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        ) : (
          <Typography align="center" variant="overline">
            Sin números de celular
          </Typography>
        )}
      </Stack>
    </Paper>
  );
}
